import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=0bccc2cd&scoped=true&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bccc2cd",
  null
  
)

export default component.exports